<template>
  <q-expansion-item
      :icon="headIcon"
      class="q-ma-xs"
      :label="`${title} (${recordList.length})`"
      :header-class="headerClass"
      expand-icon-class="text-white"
      :default-opened="defaultOpen">
    <template v-slot:header v-if="fullScreen === true">
      <q-item-section>
        {{ `${title} (${recordList.length})` }}
      </q-item-section>

      <q-item-section side>
        <q-btn icon="close" flat v-close-popup round text-color="white"/>
      </q-item-section>
    </template>
    <q-card>
      <q-card-section v-if="fullScreen" class="text-center">
        <div class="row full-width justify-center">
          <div class="col-xs-1" v-for="(item,index) in groupData" :key="index">
            <q-card class="shadow-5 q-ma-sm">
              <q-card-section class="no-padding text-center">
                <q-chip square
                        clickable
                        icon="support_agent"
                        :label="item.City_Name">
                  <q-badge floating :label="item.count" color="red" text-color="white"/>
                </q-chip>
                <q-chip square
                        color="teal"
                        text-color="white"
                        icon-right="attach_money"
                        :label="item.sum.toLocaleString()"/>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-banner dense v-if="detailsType==='factor'"
                  :class="financeServiceStatus?'bg-green text-white':'bg-red text-white'" inline-actions>
          {{ financeServiceStatus ? 'سرویس محاسبان فعال است.' : 'سرویس مالی  غیرفعال است' }}
          <template v-slot:avatar>
            <q-icon name="info"/>
          </template>
        </q-banner>
        <q-banner dense class="text-center text-subtitle2 text-bold bg-deep-purple text-white" inline-actions>
          {{
            lodash.sumBy(items.filter(rec => rec.Sale_Kind === 1), item => item.Sale_Pay ? item.Sale_Pay : 0).toLocaleString()
          }}
          <template v-slot:avatar>
            <q-icon name="attach_money"/>
          </template>
          <template v-slot:action>
            <q-btn size="sm" v-if="!fullScreen && !$q.screen.lt.md" flat color="white" icon="home_max"
                   @click="$emit('full-screen', items)"/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding" v-if="!fullScreen">
        <q-table
            :grid="gridStyle"
            :data="recordList"
            row-key="Sale_Num"
            wrap-cells
            hide-header
            :filter="filter"
            flat
            :pagination="pagination">
          <template v-slot:body="props">
            <q-tr :props="props" class="my-class">
              <q-tooltip content-class="bg-transparent" anchor="top middle">
                <q-banner rounded dense class="bg-green text-white text-subtitle1">
                  {{ title }}
                </q-banner>
              </q-tooltip>
              <q-td>
                <q-card class="shadow-10">
                  <q-card-section class="no-padding" v-if="props.row.Cs_ID===6899">
                    <q-banner rounded dense class="bg-red-14 text-white" inline-actions>
                      <span class="text-subtitle2">دیجیکالا</span>
                      <template v-slot:avatar>
                        <q-avatar>
                          <img alt="sign" src="../../assets/Sign.svg">
                        </q-avatar>
                      </template>
                    </q-banner>
                  </q-card-section>
                  <q-card-section class="no-padding"
                                  :class="props.row.LastTraceinfo==='حذف'?'no-padding bg-red-8 shadow-10':' no-padding shadow-10'">
                    <q-badge v-if="props.row.Sale_Kind && props.row.Sale_Kind===-1" rounded
                             :label="`سند برگشت`"
                             color="red-14" text-color="white"/>
                    <q-chip size="sm" icon="attach_file" color="blue-grey" flat round
                            clickable
                            label="ضمیمه دارد"
                            text-color="white"
                            @click="downloadAttachment(props.row)"
                            v-if="hasAttachment && $store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                                && props.row.HasAttachment">
                      <q-tooltip>
                        دانلود ضمیمه
                      </q-tooltip>
                    </q-chip>
                    <q-space/>
                    <q-badge v-if="props.row.DIFF!==0" rounded :label="`${props.row.DIFF} روز پیش`"
                             :color="props.row.DIFF<=365?'green-14':'red-14'" text-color="white"/>
                    <q-badge v-if="props.row.DIFF===0" rounded :label="`امروز`"
                             color="green-14" text-color="white"/>
                    <q-badge v-if="props.row.IsShopOrder" rounded :label="`خرده فروشی`"
                             color="blue-grey-14" text-color="white" class="q-ml-xs"/>
                    <q-separator spaced/>
                    <q-chip
                        :clickable="$store.state.roles.some(v=>['admin','can_change_order_user'].includes(v))"
                        @click="changeUser(props.row)"
                        :size="$q.screen.lt.md?'sm':'11px'" color="brown" text-color="white"
                        square
                        icon="support_agent"
                        :label="props.row.UserName">
                      <q-tooltip>
                        ثبت کننده
                      </q-tooltip>
                    </q-chip>
                    <q-space/>
                    <span class="wrap-sm text-blue-grey-10 text-bold q-ml-sm text-caption"
                          v-if="props.row.ReasonDescription && props.row.Sale_Kind===1">{{
                        props.row.ReasonDescription.substring(0, 50)
                      }}...
                    <q-tooltip>
                          {{props.row.ReasonDescription}}
                        </q-tooltip>
                    </span>
                    <q-space/>
                    <q-badge v-if="props.row.Remain" rounded
                             :label="`تعداد ${props.row.Remain} عدد کالا حواله نشده وجود دارد`"
                             color="red-14" text-color="white" class="text-bold"/>
                    <q-space/>
                    <q-badge outline v-if="props.row.DecreaseCount && props.row.DecreaseCount>0"
                             rounded
                             :label="`تعداد (${props.row.DecreaseCount}) قلم کالا دارای کسری موجودی می باشد`"
                             color="red" text-color="white" class="text-bold"/>
                    <q-separator spaced/>
                    <q-badge class="q-ml-xs" :size="$q.screen.lt.md?'sm':'11px'"
                             v-if="props.row.RemainOrder && props.row.RemainOrder===1 || (props.row.Remain>0 && props.row.Remain!==props.row.Sale_Count)"
                             color="pink"
                             text-color="white" label="مانده سفارش" icon="tag"/>
                    <q-space/>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="apartment"
                            :label="props.row.CompName"/>
                    <q-chip clickable v-if="props.row.Visitor_Name" size="sm" square
                            icon="local_shipping"
                            label="کرایه حمل بار" @click="setDriver(props.row)">
                      <q-tooltip content-class="bg-red-14 text-white"
                                 v-if="props.row.Transfer_Cost">
                        {{ `کرایه: ${props.row.Transfer_Cost.toLocaleString()}` }}
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding" v-if="props.row.City_Name">
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="person"
                            :label="props.row.Cs_Name"
                            @click="showCustomerInfo(props.row)">
                    </q-chip>
                    <q-btn flat round
                           replace
                           icon="edit"
                           color="indigo"
                           size="sm"
                           @click="customerSelect(props.row)"
                           v-if="orderTrace && !props.row.OrderLock && !props.row.Hava_Num
                              && $store.state.roles.some(v=>['admin','can_change_ordre_customer_after_insert'].includes(v))"
                           padding="none"/>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="person"
                            :label="props.row.State_Name"/>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="brown" text-color="white"
                            square
                            icon="support_agent"
                            :label="props.row.City_Name"/>
                    <q-separator spaced/>
                  </q-card-section>
                  <q-card-section v-if="props.row.Sale_Kind===-1" class="no-padding text-center">
                    <q-chip size="11px" square v-if="detailsType==='factor'" color="teal"
                            text-color="white"
                            :label="props.row.BaseSale_Num" clickable icon="shopping_basket"
                            @click="showBaseFactorDetails(props.row)">
                      <q-tooltip>
                        شماره فاکتور اصلی
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding text-center">
                    <q-chip clickable size="11px" color="purple"
                            v-if="props.row.Sale_Kind && props.row.Sale_Kind===1"
                            text-color="white"
                            :label="detailsType==='order'?props.row.Sale_Num:props.row.Order_Num"
                            square icon="shopping_basket" @click="showOrderDetails(props.row)">
                      <q-tooltip>
                        شماره سفارش
                      </q-tooltip>
                    </q-chip>
                    <q-chip size="11px" v-if="detailsType!=='order'" clickable color="purple"
                            text-color="white"
                            :label="detailsType==='factor'?props.row.Hava_Num:props.row.Sale_Num"
                            square icon="door_back" @click="showHavaDetails(props.row)">
                      <q-tooltip>
                        شماره حواله
                      </q-tooltip>
                    </q-chip>
                    <q-chip size="11px" square v-if="detailsType==='factor'" color="teal"
                            text-color="white"
                            :label="props.row.Sale_Num" clickable icon="shopping_basket"
                            @click="showFactorDetails(props.row)">
                      <q-tooltip>
                        شماره فاکتور
                      </q-tooltip>
                    </q-chip>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="red" text-color="white"
                            :label="props.row.Sale_Date"
                            square icon="calendar_today">
                      <q-tooltip>
                        تاریخ
                      </q-tooltip>
                    </q-chip>
                    <q-chip v-if="props.row.Sale_Pay" :size="$q.screen.lt.md?'sm':'11px'"
                            color="deep-orange"
                            text-color="white" square icon="paid"
                            :label="props.row.Sale_Pay | toCurrency">
                      <q-tooltip>
                        {{ detailsType === 'factor' ? 'مبلغ فاکتور' : ' مبلغ سفارش' }}
                      </q-tooltip>
                    </q-chip>
                    <q-space/>
                    <q-chip size="11px"
                            v-if="props.row.WayBillNumber" color="purple"
                            text-color="white" :label="props.row.WayBillNumber"
                            square icon="local_shipping">
                      <q-tooltip>
                        شماره بارنامه
                      </q-tooltip>
                    </q-chip>
                    <q-space
                        v-if="props.row.BuyDay_Pay && $store.state.roles.some(v=>['admin','can_see_buy_price_summary_order_trace'].includes(v))"/>
                    <q-chip size="11px"
                            v-if="props.row.BuyDay_Pay && $store.state.roles.some(v=>['admin','can_see_buy_price_summary_order_trace'].includes(v))"
                            :color="props.row.Sale_Pay - props.row.BuyDay_Pay>0?'green-10':'red-10'"
                            text-color="white" label="اختلاف خرید و فروش"
                            square icon="attach_money">
                      <q-badge color="indigo-10" class="q-ml-xs">
                                                <span dir="ltr">{{
                                                    (props.row.Sale_Pay - props.row.BuyDay_Pay).toLocaleString()
                                                  }}</span>
                      </q-badge>
                    </q-chip>
                  </q-card-section>
                  <q-card-actions align="center" class="no-padding">
                    <q-btn
                        v-if="props.row.Sale_State===0 && orderTrace && !props.row.OrderLock
                        && (parseInt(props.row.Sale_UserID)===parseInt($store.state.userId)
                        || $store.state.roles.some(v=>['admin','can_edit_sale_order_without_change_agent_name'].includes(v)))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="indigo"
                        icon="edit"
                        @click="editOrder(props.row.Sale_Num, props.row.Sale_State)">
                      <q-tooltip>
                        ویرایش سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Sale_State===0 && orderTrace && $store.state.roles.some(v=>['admin','user','user_visitor'].includes(v)) && !props.row.OrderLock"
                        flat padding="none" size="md" round
                        class="q-mt-xs"
                        @click="refreshPrice(props.row)"
                        color="indigo" icon="refresh">
                      <q-tooltip>
                        بازسازی قیمت ها
                      </q-tooltip>
                    </q-btn>

                    <q-btn
                        v-if="props.row.Sale_State===0 && orderTrace && $store.state.roles.some(v=>['admin','user','user_visitor'].includes(v)) && !props.row.OrderLock"
                        flat padding="none" size="md" round
                        class="q-mt-xs"
                        color="positive" icon="check"
                        @click="setSaleStateFlag(props.row)">
                      <q-tooltip>
                        تایید سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="orderTrace && props.row.Sale_State===1 && (props.row.Sale_StateModir===0 || !props.row.Sale_StateModir) && $store.state.roles.some(v=>['admin','can_final_order'].includes(v)) && !props.row.OrderLock"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="positive" icon="done_all"
                        @click="setFinalSaleState(props.row)">
                      <q-tooltip>
                        تایید مالی سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Sale_State===1 && orderTrace &&
                                                stageOrder2
                                                && $store.state.roles.some(v=>['admin','can_return_order_from_stage1'].includes(v)) && !props.row.OrderLock"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="negative" icon="east"
                        @click="backOrderStage1(props.row)">
                      <q-tooltip>
                        برگشت سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Sale_State===1 && orderTrace && stageOrder3 && $store.state.roles.some(v=>['admin','can_return_order_from_stage2'].includes(v)) && !props.row.OrderLock"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="negative" icon="east"
                        @click="backOrderStage2(props.row)">
                      <q-tooltip>
                        برگشت سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn flat padding="none" size="md" round class="q-mt-xs"
                           color="indigo"
                           icon="print"
                           v-if="orderTrace"
                           @click="printOrder(props.row.Sale_Num, props.row.CompID, props.row)">
                      <q-tooltip>
                        چاپ سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn flat padding="none" size="md" round class="q-mt-xs"
                           color="indigo"
                           icon="print"
                           v-if="havaActions"
                           @click="printHava(props.row)"/>
                    <q-btn flat padding="none" size="md" round class="q-mt-xs"
                           color="indigo"
                           icon="print"
                           v-if="detailsType==='factor'"
                           @click="printfactor(props.row.Sale_Num, props.row.CompID, props.row)">
                      <q-tooltip>
                        چاپ فاکتور
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat icon="timeline" color="indigo"
                           @click="showOrderTimeLine(props.row)">
                      <q-tooltip>
                        رهگیری سفارش
                      </q-tooltip>
                    </q-btn>

                    <q-btn v-if="detailsType==='order' && props.row.Sale_State===1 && props.row.Sale_StateModir===1
                          && $store.state.roles.some(v=>['admin','can_issue_sale'].includes(v))
                          && !props.row.OrderLock && !VisitorView"
                           round flat icon="flaky" color="indigo"
                           @click="showOrderRemittanceForm(props.row)">
                      <q-tooltip>
                        صدور حواله
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="canRemoveDriver && $store.state.roles.some(v=>['admin','can_set_drive_price'].includes(v)) && !props.row.OrderLock"
                        round flat icon="local_shipping" color="red"
                        @click="returnToStage4(props.row)">
                      <q-tooltip>
                        برگشت
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="canSetDrive && $store.state.roles.some(v=>['admin','can_set_drive_price'].includes(v))"
                        round flat icon="local_shipping"
                        :color="props.row.Visitor_Name?'green':'indigo'"
                        @click="SetDriver(props.row)">
                      <q-tooltip>
                        {{
                          props.row.Visitor_Name ? 'کرایه بار انتخاب شده است' : 'تعیین کرایه بار'
                        }}
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="canFinalExit && props.row.Visitor_Name
                        && $store.state.roles.some(v=>['admin','can_confirm_exit_product_from_store', 'can_sea_exit_product'].includes(v))"
                        round color="positive" icon="check" padding="none"
                        class="q-mt-xs" @click="setHavaState(props.row)">
                      <q-tooltip>
                        {{
                          props.row.Co !== 0 ? 'برخی انبارها تاییدیه خود را نزده اند' : 'اقلام حواله آماده سازی و حواله برای تحویل به طرف معامله مورد تایید است'
                        }}
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="canMakeFactor && props.row.Sale_State===1 && $store.state.roles.some(v=>['admin','can_make_factor'].includes(v))"
                        round flat icon="done_all" color="positive"
                        @click="makeFactor(props.row)">
                      <q-tooltip>
                        صدور فاکتور
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.CustomerRequestID && $store.state.roles.some(v=>['admin','can_send_factor'].includes(v))"
                        round flat icon="mail" color="indigo"
                        @click="sendFactorLink(props.row.CustomerRequestID, props.row.Cs_Mobile,detailsType==='factor'?'فاکتور':'سفارش',props.row.Cs_Name, props.row.Sale_Num, props.row)">
                      <q-tooltip>
                        ارسال برای طرف معامله
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.OrderLock!==undefined && $store.state.roles.some(v=>['admin','can_chane_order_lock_state'].includes(v))"
                        round flat :icon="props.row.OrderLock===0?'lock_open':'lock'"
                        :color="props.row.OrderLock===0?'green-10':'red-10'"
                        @click="orderStateChanging(props.row)">
                      <q-tooltip>
                        {{ props.row.OrderLock === 0 ? 'سفارش فعال است' : 'سفارش غیرفعال است' }}
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="havaActions && allowDeleteHava && $store.state.roles.some(v=>['admin','can_remittance_of_goods'].includes(v))"
                        :disable="props.row.LastTraceinfo!=='حذف'"
                        round flat icon="delete" color="red"
                        @click="deleteHava(props.row.Sale_Num)">
                      <q-tooltip>
                        حذف حواله
                      </q-tooltip>
                    </q-btn>

                    <q-btn
                        v-if="havaActions && !canMakeFactor && !canFinalExit && !canSetDrive"
                        round flat icon="info" color="indigo" @click="loadStorList(props.row)">
                      <q-tooltip>
                        لیست تایدییه انباردار/انباردران
                      </q-tooltip>
                    </q-btn>

                    <q-btn
                        v-if="detailsType==='factor' && props.row.Sale_State===0"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="positive" icon="check"
                        @click="setFactorSaleState(props.row)">
                      <q-tooltip>
                        نهایی نمودن فاکتور
                      </q-tooltip>
                    </q-btn>

                    <q-btn
                        v-if="detailsType==='factor' &&
                                                props.row.Sale_State===1 &&
                                                props.row.HasAttachment &&
                                                $store.state.roles.some(v=>['admin','can_issue_finance_from_factory'].includes(v))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="positive" icon="done_all"
                        :id="`factor${props.row.Sale_Num}`"
                        @click="issueFinanceDocument(props.row)">
                      <q-tooltip>
                        صدور سند مالی
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="attach_file" color="blue-grey" flat round
                           @click="loadUploadDialog(props.row)"
                           v-if="hasAttachment && $store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && !props.row.HasAttachment">
                      <q-tooltip>
                        ضمیمه نمودن فاکتور فروش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="detailsType==='factor' && $store.state.roles.some(v=>['admin','can_delete_factor'].includes(v))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="negative" icon="delete"
                        :disable="props.row.LastTraceinfo!=='حذف' && props.row.Sale_Kind===1"
                        @click="deleteFactor(props.row)">
                      <q-tooltip>
                        حذف فاکتور
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="layers_clear" color="red-10" flat round
                           v-if="hasAttachment && $store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && props.row.HasAttachment"
                           @click="removeAttachment(props.row)">
                      <q-tooltip>
                        حذف ضمیمه
                      </q-tooltip>
                    </q-btn>
                  </q-card-actions>
                </q-card>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>

      <q-card-section class="no-padding" v-if="fullScreen">
        <div class="row full-width flex flex-center">
          <q-tooltip content-class="bg-transparent" anchor="top middle">
            <q-banner rounded dense class="bg-green text-white text-subtitle1">
              {{ title }}
            </q-banner>
          </q-tooltip>
          <q-card v-for="(item, index) in items" :key="index" class="q-ma-md shadow-10 col-xs-12 col-md-2">
            <q-card-section class="no-padding" v-if="item.Cs_ID===6899">
              <q-banner rounded dense class="bg-red-14 text-white" inline-actions>
                <span class="text-subtitle2">دیجیکالا</span>
                <template v-slot:avatar>
                  <q-avatar>
                    <img alt="sign" src="../../assets/Sign.svg">
                  </q-avatar>
                </template>
              </q-banner>
            </q-card-section>

            <q-card-section class="no-padding">
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="brown" text-color="white" square
                      icon="support_agent"
                      :label="item.UserName">
                <q-tooltip>
                  ثبت کننده
                </q-tooltip>
              </q-chip>
              <q-space/>
              <span class="wrap-sm text-blue-grey-10 text-bold q-ml-sm text-caption"
                    v-if="item.ReasonDescription && item.Sale_Kind===1">
                {{ item.ReasonDescription.substring(0, 50) }}...</span>
              <q-space/>
              <q-badge v-if="item.Sale_Kind && item.Sale_Kind===-1" rounded :label="`سند برگشت`"
                       color="red-14" text-color="white"/>
              <q-space/>
              <q-badge v-if="item.Remain" rounded
                       :label="`تعداد ${item.Remain} عدد کالا حواله نشده وجود دارد`"
                       color="red-14" text-color="white" class="text-bold"/>
              <q-badge outline v-if="item.DecreaseCount && item.DecreaseCount>0" rounded
                       :label="`تعداد ${item.DecreaseCount} قلم کالا دارای کسری موجودی می باشد`"
                       color="red" text-color="white" class="text-bold"/>

              <q-separator spaced class="no-padding"/>
              <q-badge v-if="item.DIFF!==0" rounded :label="`${item.DIFF} روز پیش`"
                       :color="item.DIFF<=365?'green-14':'red-14'" text-color="white"/>

              <q-badge v-if="item.DIFF===0" rounded :label="`امروز`"
                       color="green-14" text-color="white"/>
              <q-badge class="q-ml-xs" :size="$q.screen.lt.md?'sm':'11px'"
                       v-if="item.RemainOrder && item.RemainOrder===1 || (item.Remain>0 && item.Remain!==item.Sale_Count)"
                       color="pink"
                       text-color="white" label="مانده سفارش" icon="tag"/>
              <q-badge v-if="item.isShopOrder" rounded :label="`خرده فروشی`"
                       color="blue-grey-14" text-color="white" class="q-ml-xs"/>
              <q-space/>
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="apartment"
                      :label="item.CompName"/>
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="person"
                      :label="item.Cs_Name"
                      @click="showCustomerInfo(item)"/>
              <q-space/>

              <q-chip clickable v-if="item.Visitor_Name" size="sm" square icon="local_shipping"
                      label="کرایه حمل بار" @click="SetDriver(item)">
                <q-tooltip content-class="bg-red-14 text-white" v-if="item.Transfer_Cost">
                  {{ `کرایه: ${item.Transfer_Cost.toLocaleString()}` }}
                </q-tooltip>
              </q-chip>

            </q-card-section>
            <q-card-section class="no-padding" v-if="item.City_Name">
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="person"
                      :label="item.State_Name"/>
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="brown" text-color="white" square
                      icon="support_agent"
                      :label="item.City_Name"/>
            </q-card-section>
            <q-card-section class="no-padding">
              <q-chip clickable size="11px" color="purple"
                      v-if="item.Sale_Kind && item.Sale_Kind===1"
                      text-color="white" :label="detailsType==='order'?item.Sale_Num:item.Order_Num"
                      square icon="shopping_basket" @click="showOrderDetails(item)">
                <q-tooltip>
                  شماره سفارش
                </q-tooltip>
              </q-chip>
              <q-chip size="11px" v-if="detailsType!=='order'" clickable color="purple"
                      text-color="white" :label="detailsType==='factor'?item.Hava_Num:item.Sale_Num"
                      square icon="door_back" @click="showHavaDetails(item)">
                <q-tooltip>
                  شماره حواله
                </q-tooltip>
              </q-chip>
              <q-chip size="11px" square v-if="detailsType==='factor'" color="teal" text-color="white"
                      :label="item.Sale_Num" clickable icon="shopping_basket"
                      @click="showFactorDetails(item)">
                <q-tooltip>
                  شماره فاکتور
                </q-tooltip>
              </q-chip>
              <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="red" text-color="white"
                      :label="item.Sale_Date"
                      square icon="calendar_today">
                <q-tooltip>
                  تاریخ
                </q-tooltip>
              </q-chip>
              <q-chip v-if="item.Sale_Pay" :size="$q.screen.lt.md?'sm':'11px'" color="deep-orange"
                      text-color="white" square icon="paid"
                      :label="item.Sale_Pay | toCurrency">
                <q-tooltip>
                  {{ detailsType === 'factor' ? 'مبلغ فاکتور' : ' مبلغ سفارش' }}
                </q-tooltip>
              </q-chip>
              <q-space/>
              <q-chip size="11px" v-if="item.WayBillNumber" color="purple"
                      text-color="white" :label="item.WayBillNumber"
                      square icon="local_shipping">
                <q-tooltip>
                  شماره بارنامه
                </q-tooltip>
              </q-chip>
            </q-card-section>
            <q-card-actions>
              <q-btn
                  v-if="item.Sale_State===0 && orderTrace && !item.OrderLock
                        && (item.Sale_UserID===$store.state.userId || $store.state.roles.some(v=>['admin'].includes(v)))"
                  flat size="md" round class="q-mt-xs"
                  color="indigo"
                  icon="edit"
                  @click="editOrder(item.Sale_Num, item.Sale_State)">
                <q-tooltip>
                  ویرایش سفارش
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="item.Sale_State===0 && orderTrace"
                  flat size="md" round
                  class="q-mt-xs"
                  color="positive" icon="refresh">
                <q-tooltip>
                  به روز رسانی قیمت ها
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="item.Sale_State===0 && orderTrace && $store.state.roles.some(v=>['admin','user','user_visitor'].includes(v))"
                  flat padding="none" size="md" round
                  class="q-mt-xs"
                  color="positive" icon="check"
                  @click="setSaleStateFlag(item)">
                <q-tooltip>
                  تایید سفارش
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="orderTrace && item.Sale_State===1 && item.Sale_StateModir===0 && $store.state.roles.some(v=>['admin','can_final_order'].includes(v))"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="positive" icon="done_all"
                  @click="setFinalSaleState(item)">
                <q-tooltip>
                  تایید مالی سفارش
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="item.Sale_State===1 && orderTrace && stageOrder2 && $store.state.roles.some(v=>['admin','can_return_order_from_stage1'].includes(v))"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="negative" icon="east"
                  @click="backOrderStage1(item)">
                <q-tooltip>
                  برگشت سفارش
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="item.Sale_State===1 && orderTrace && stageOrder3 && $store.state.roles.some(v=>['admin','can_return_order_from_stage2'].includes(v))"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="negative" icon="east"
                  @click="backOrderStage2(item)">
                <q-tooltip>
                  برگشت سفارش
                </q-tooltip>
              </q-btn>
              <q-btn flat padding="none" size="md" round class="q-mt-xs"
                     color="indigo"
                     icon="print"
                     v-if="orderTrace"
                     @click="printOrder(props.row.Sale_Num, props.row.CompID, props.row)">
                <q-tooltip>
                  چاپ سفارش
                </q-tooltip>
              </q-btn>
              <q-btn flat padding="none" size="md" round class="q-mt-xs"
                     color="indigo"
                     icon="print"
                     v-if="havaActions"
                     @click="printHava(item.Sale_Num)"/>
              <q-btn flat padding="none" size="md" round class="q-mt-xs"
                     color="indigo"
                     icon="print"
                     v-if="detailsType==='factor'"
                     @click="printfactor(item.Sale_Num, item.CompID, item)"/>
              <q-btn round flat icon="timeline" color="indigo"
                     @click="showOrderTimeLine(item)">
                <q-tooltip>
                  رهگیری سفارش
                </q-tooltip>
              </q-btn>
              <q-btn v-if="detailsType==='order' && item.Sale_State===1 && item.Sale_StateModir===1
                          && $store.state.roles.some(v=>['admin','can_issue_sale'].includes(v))"
                     round flat icon="flaky" color="indigo" @click="showOrderRemittanceForm(item)">
                <q-tooltip>
                  صدور حواله
                </q-tooltip>
              </q-btn>

              <q-btn
                  v-if="canSetDrive && $store.state.roles.some(v=>['admin','can_set_drive_price'].includes(v))"
                  round flat icon="local_shipping" color="red"
                  @click="returnToStage4(item)">
                <q-tooltip>
                  برگشت
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="canSetDrive && $store.state.roles.some(v=>['admin','can_set_drive_price'].includes(v))"
                  round flat icon="local_shipping" :color="item.Visitor_Name?'green':'indigo'"
                  @click="SetDriver(item)">
                <q-tooltip>
                  {{ item.Visitor_Name ? 'کرایه بار انتخاب شده است' : 'تعیین کرایه بار' }}
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="canFinalExit && item.Visitor_Name
                        && $store.state.roles.some(v=>['admin','can_confirm_exit_product_from_store', 'can_sea_exit_product'].includes(v))"
                  round color="positive" icon="check" padding="none"
                  class="q-mt-xs" @click="setHavaState(item)">
                <q-tooltip>
                  {{
                    item.Co !== 0 ? 'برخی انبارها تاییدیه خود را نزده اند' : 'اقلام حواله آماده سازی و حواله برای تحویل به طرف معامله مورد تایید است'
                  }}
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="canMakeFactor&& item.Sale_State===1 && $store.state.roles.some(v=>['admin','can_make_factor'].includes(v))"
                  round flat icon="done_all" color="positive" @click="makeFactor(item)">
                <q-tooltip>
                  صدور فاکتور
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="item.CustomerRequestID && $store.state.roles.some(v=>['admin','can_send_factor'].includes(v))"
                  round flat icon="mail" color="indigo"
                  @click="sendFactorLink(item.CustomerRequestID, item.Cs_Mobile,detailsType==='factor'?'فاکتور':'سفارش',item.Cs_Name, item.Sale_Num)">
                <q-tooltip>
                  ارسال برای طرف معامله
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="havaActions && allowDeleteHava && $store.state.roles.some(v=>['admin','can_remittance_of_goods'].includes(v))"
                  :disable="item.LastTraceinfo!=='حذف' && item.Sale_Kind===1"
                  round flat icon="delete" color="red" @click="deleteHava(item.Sale_Num)">
                <q-tooltip>
                  حذف حواله
                </q-tooltip>
              </q-btn>

              <q-btn
                  v-if="havaActions && !canMakeFactor && !canFinalExit && !canSetDrive"
                  round flat icon="info" color="indigo" @click="loadStorList(item)">
                <q-tooltip>
                  لیست تایدییه انباردار/انباردران
                </q-tooltip>
              </q-btn>

              <q-btn
                  v-if="detailsType==='factor' && item.Sale_State===0"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="positive" icon="check"
                  @click="setFactorSaleState(item)">
                <q-tooltip>
                  نهایی نمودن فاکتور
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="detailsType==='factor' && item.Sale_State===1 && $store.state.roles.some(v=>['admin','can_issue_finance_from_factory'].includes(v))"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="positive" icon="done_all"
                  @click="issueFinanceDocument(item)">
                <q-tooltip>
                  صدور سند مالی
                </q-tooltip>
              </q-btn>
              <q-btn
                  v-if="detailsType==='factor' && $store.state.roles.some(v=>['admin','can_delete_factor'].includes(v))"
                  flat padding="none" size="md" round class="q-mt-xs"
                  color="negative" icon="delete"
                  :disable="item.LastTraceinfo!=='حذف' && props.row.Sale_Kind===1"
                  @click="deleteFactor(item)">
                <q-tooltip>
                  حذف فاکتور
                </q-tooltip>
              </q-btn>
            </q-card-actions>
            <q-card-section class="no-padding">
              <q-banner dense class="bg-teal text-white text-subtitle2" v-if="canSetDrive && item.Co!==0">
                توسط انباردار آماده سازی نشده است
              </q-banner>
            </q-card-section>
          </q-card>
        </div>
      </q-card-section>
    </q-card>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <customer-info :selectedCustomer="selectedCustomer"/>
    </q-dialog>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <order-details v-if="!$q.screen.lt.md" :store_id="null" :hava_num="null" :sale-num="selectedSaleNum"/>
      <OrderDetailsMobile v-if="$q.screen.lt.md" :store_id="null" :hava_num="null" :sale-num="selectedSaleNum"/>
    </q-dialog>

    <q-dialog
        maximized
        v-model="showHavaDetailsDialog">
      <hava-details :store_id="[1,2,3,4,5,6]" :hava_num="selectedHavaNum" :sale-num="selectedSaleNum"

                    :sale-kind="selectedSaleKind"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="selectedSaleNum"
                     :sale-date="selectedSaleDate"
                     :remain-ordered="!!(selectedItem.RemainOrder && selectedItem.RemainOrder===1 ||
                     (selectedItem.Remain>0 && selectedItem.Remain!==selectedItem.Sale_Count))"
                     @refresh-data="$emit('refresh-data');"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="driverDialog">
      <Driver :sale_num="selectedHavaNum" @close-driver-dialog="closeDriverDialog"/>
    </q-dialog>

    <q-dialog maximized v-model="factorDialogVisibility">
      <FactorDetails :sale-num="selectedSaleNum" :factor-items="factorItems" :sale-kind="selectedSaleKind"
                     :sale-state="0"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="orderStoreListDialog">
      <OrderStoreList :items="orderStoreList"/>
    </q-dialog>

    <q-dialog v-model="showOrderRemittanceDialog" maximized>
      <IssueOrderRemittance :order-num="parseInt(selectedOrderNum)" @refresh-data="closeIssueOrder"/>
    </q-dialog>

    <q-dialog v-model="changeUserDialog">
      <ChangeOrderUser :user="selectedItem"/>
    </q-dialog>

    <q-dialog v-model="uploadDocumentDialog">
      <SaleFacLisAttachment v-if="selectedOrder && selectedOrder.Sale_Num"
                            :filename="selectedOrder.Sale_Num.toString()"
                            @uploaded_finish="uploadedFinish"
                            :file-kind="selectedOrder.Sale_Kind"/>
    </q-dialog>
    <q-dialog v-model="selectCustomerDialog" full-width>
      <SelectCustomer :buy-list="false" :selected-customer="selectedCustomer"
                      :is-dialog="true"
                      :title="`انتخاب مشتری `"
                      @customerSelected="event=>immediatelyCustomerSelected(event)"/>
    </q-dialog>
    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog :factor-info="selectedItem" title="چاپ فاکتور"/>
    </q-dialog>

    <q-dialog v-model="orderPrintDialog">
      <OrderPrintDialog :order-info="selectedItem" title="چاپ سفار"/>
    </q-dialog>

  </q-expansion-item>
</template>

<script>
import CustomerInfo from "@/components/customers/CustomerInfo";
import {mapActions} from "vuex";
import OrderDetails from "@/components/customers/OrderDetails";
import HavaDetails from "@/components/customers/HavaDetails";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import Driver from "@/components/Driver/Driver";
import FactorDetails from "@/components/Factor/FactorDetails";
import OrderStoreList from "@/components/orders/OrderStoreList";
import IssueOrderRemittance from "@/components/Remittance/IssueOrderRemittance";
import ChangeOrderUser from "@/components/OrderTrace/ChangeOrderUser";
import OrderDetailsMobile from "@/components/customers/OrderDetailsMobile";
import SaleFacLisAttachment from "@/components/orders/SaleFacListAttachment.vue";
import SelectCustomer from "@/components/customers/SelectCustomer.vue";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";
import OrderPrintDialog from "@/components/PrintDialogs/OrderPrintDialog.vue";


export default {
  name: "OrderList",
  components: {
    OrderPrintDialog,
    FactorPrintDialog,
    SelectCustomer,
    SaleFacLisAttachment,
    OrderDetailsMobile,
    ChangeOrderUser,
    IssueOrderRemittance,
    OrderStoreList, FactorDetails, Driver, OrderTimeLine, HavaDetails, OrderDetails, CustomerInfo
  },
  props: {
    headerClass: {
      type: String
    },
    defaultOpen: {
      type: Boolean,
      required: false,
      default: true
    },
    gridStyle: {
      type: Boolean,
      default: false
    },
    headIcon: {
      type: String,
      default: ''
    },
    filter: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    detailsType: {
      type: String,
      required: true,
    },
    orderTrace: {
      type: Boolean,
      required: true
    },
    havaActions: {
      type: Boolean
    },
    allowDeleteHava: {
      type: Boolean,
      default: false
    },
    stageOrder2: {
      type: Boolean,
      default: false
    },
    stageOrder3: {
      type: Boolean,
      default: false
    },
    canSetDrive: {
      type: Boolean
    },
    financeServiceStatus: {
      type: Boolean
    },
    canMakeFactor: {
      type: Boolean,
      required: true
    },
    canFinalExit: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    stageNumber: {
      type: Number
    },
    canRemoveDriver: {
      type: Boolean
    },
    VisitorView: {
      type: Boolean,
      default: false
    },
    hasAttachment: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectCustomerDialog: false,
      groupData: [],
      changeUserDialog: false,
      selectedItem: '',
      selectedOrderNum: '',
      showOrderRemittanceDialog: false,
      orderStoreListDialog: false,
      expired: false,
      compName: null,
      stateName: null,
      cityName: null,
      driverDialog: false,
      showTimeLineDialog: false,
      showHavaDetailsDialog: false,
      selectedSaleKind: 0,
      showCustomerFullInfo: false,
      showOrderDetailsDialog: false,
      selectedSaleNum: 0,
      selectedCustomer: undefined,
      selectedHavaNum: 0,
      factorDialogVisibility: false,
      factorItems: [],
      orderStoreList: [],
      pagination: {
        rowsPerPage: 5
      },
      CustomPay: 0,
      CustomText: '',
      selectedSaleDate: '',
      selectedOrder: undefined,
      uploadDocumentDialog: false,
      factorPrintDialog: false,
      orderPrintDialog:false
    }
  },
  methods: {
    ...mapActions({
      getCustomerInfo: 'Customers/get_customer_info',
      deleteHavaleh: 'Orders/deleteHavaleh',
      setSaleState: 'Orders/setSaleState',
      setFinalOrder: 'Orders/setSaleFinalState',
      returnOrderStage1: 'Orders/returnOrderStage1',
      returnOrderStage2: 'Orders/returnOrderStage2',
      setExiState: 'Orders/setExiSaleState',
      issueFactorDocument: 'Requests/issueFinanceDocument',
      setFactorState: 'Requests/setFactorSaleState',
      generateFactory: 'Orders/generateFactor',
      deleteFactorBySaleNum: 'Orders/deleteFactor',
      showFactorItems: 'Orders/getFactorItems',
      SendSMS: 'send_sms_by_user',
      setOrderStoreList: 'Orders/getOrderStoreList',
      setReturnToStage4: 'Orders/returnToStage4',
      refreshOrderPrice: 'Orders/refreshOrderPrice',
      changeOrderState: 'Orders/lockOrder',
      sendPay: 'Deboters/sendPayLink',
      setAttachmentFlag: 'Orders/setSaleFactorAttachmentFlag',
      downloadFile: 'Orders/downloadFile',
      updateCustomerOrder: 'Orders/updateOrderCustomer',
    }),
    customerSelect(rowInfo) {
      this.selectedItem = rowInfo
      this.selectCustomerDialog = true
    },
    immediatelyCustomerSelected(args) {
      this.updateCustomerOrder({
        saleNum: this.selectedItem.Sale_Num,
        saleKind: this.selectedItem.Sale_Kind,
        newId: args.Cs_ID
      }).then(() => {
        this.selectedItem.Cs_Name = args.Cs_Name
        this.selectCustomerDialog = false
      })
    },
    loadUploadDialog(rowInfo) {
      this.selectedOrder = rowInfo
      this.uploadDocumentDialog = true
    },
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `SaleOrders/${args.Sale_Num}_${args.Sale_Kind}.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    removeAttachment(args) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'ضمیمه حذف شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.setAttachmentFlag({Sale_Num: args.Sale_Num, Sale_Kind: args.Sale_Kind, flag: 0}).then(() => {
          this.$emit('attachment_removed', args)
        })
      })
    },
    uploadedFinish(args) {
      this.$emit('attachment-uploaded', args)
      this.uploadDocumentDialog = false
    },
    orderStateChanging(rowInfo) {
      this.changeOrderState(
          {
            saleNum: rowInfo.Sale_Num,
            saleKind: rowInfo.Sale_Kind,
            lockState: rowInfo.OrderLock === 0 ? 1 : 0
          }
      ).then((res) => {
        if (res.result === 1) {
          rowInfo.OrderLock = rowInfo.OrderLock === 0 ? 1 : 0
        }
      })
    },
    changeUser(row) {
      this.selectedItem = row
      this.changeUserDialog = true
    },
    returnToStage4(row) {
      this.setReturnToStage4(row.Sale_Num).then(() => {
        this.$emit('refresh-data');
      })
    },
    closeIssueOrder() {
      this.showOrderRemittanceDialog = false;
      this.$emit('refresh-data');
    },
    showOrderRemittanceForm(row) {
      this.selectedOrderNum = row.Sale_Num
      this.showOrderRemittanceDialog = true
    },
    loadStorList(row) {
      this.setOrderStoreList(row.Sale_Num).then((res) => {
        this.orderStoreList = res
        this.orderStoreListDialog = true
      })
    },
    showFactorDetails(row) {
      this.selectedSaleNum = row.Sale_Num
      this.selectedSaleKind = row.Sale_Kind
      this.showFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: row.Sale_Kind
      }).then((res) => {
        this.factorItems = res;
        this.factorDialogVisibility = true
      })
    },
    showBaseFactorDetails(row) {
      this.selectedSaleNum = row.BaseSale_Num
      this.selectedSaleKind = 1
      this.showFactorItems({
        sale_num: row.BaseSale_Num,
        sale_kind: 1
      }).then((res) => {
        this.factorItems = res;
        this.factorDialogVisibility = true
      })
    },
    makeFactor(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'فاکتور صادر شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        if (row.WayBillNumber !== null || row.ShopItemCount > 0 || [1139, 3218, 5183].includes(row.Cs_ID)) {
          this.generateFactory(row).then((res) => {
            this.$q.notify({
              message: `فاکتور به شماره ${res.data[0].Sale_Num} صادر شد`,
              position: 'top',
              color: 'negative',
              type: 'negative'
            })
            this.$emit('refresh-data')
          })
        } else {
          this.$q.notify({
            message: 'به دلیل نبود بارنامه امکان صدور فاکتور وجود ندارد',
            position: 'top',
            color: 'negative',
            type: 'negative'
          })
        }
      })
    },
    deleteFactor(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف فاکتور اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteFactorBySaleNum({
          saleNum: row.Sale_Num,
          saleKind: row.Sale_Kind
        }).then(() => {
          this.$emit('refresh-data')
        })
      })
    },
    setHavaState(row) {
      if (row.Co !== 0) {
        this.$q.notify({
          message: 'به دلیل اینکه برخی انبارهای تاییدیه خود را ثبت نکرده اند امکان خروج کالا میسر نیست',
          position: 'top',
          color: 'negative',
          type: 'negative'
        })
      } else {
        if (row.LastTraceinfo !== 'تاییدیه هماهنگی با طرف معامله جهت تحویل کالا') {
          this.$q.notify({
            message: 'به دلیل عدم ثبت برچسب هماهنگی با طرف معامله به عنوان آخرین برچسب، امکان ثبت تاییدیه خروج میسر نمی باشد.',
            position: 'top',
            color: 'negative',
            type: 'negative'
          })
        } else {
          this.$q.dialog({
            title: 'تاییدیه',
            message: 'از تایید حواله اطمینان دارید؟',
            cancel: true,
            persistent: true
          }).onOk(() => {
            this.setExiState(row.Sale_Num).then((res) => {
              if (res.data.msg === 'unSuccess') {
                this.$q.notify({
                  message: `کرایه تعیین نشده است`,
                  color: 'negative',
                  position: 'top',
                  type: 'negative'
                });
              } else {
                this.$q.notify({
                  message: `حواله تایید گردید`,
                  color: 'positive',
                  position: 'top',
                  type: 'positive'
                });
                this.$emit('refresh-data', {type: 6, rowInfo: row});
              }
            })
          })
        }
      }
    },
    closeDriverDialog() {
      this.$emit('refresh-data')
      this.driverDialog = false
    },
    editOrder(sale_num, state) {
      this.$router.push(`/orders-list/${sale_num}/${state}`);
    },
    async printOrder(sale_num, orderType, item) {
      this.selectedItem = item
      this.orderPrintDialog = true
    },
    async printHava(item) {
      this.selectedItem = item
      this.orderPrintDialog = true
    },
    async printfactor(sale_num, orderType, item) {
      this.selectedItem = item
      this.factorPrintDialog = true
    },
    async sendFactorLink(requestid, phoneNo, ty, customerName, sale_num, item) {
      this.$q.dialog({
        title: 'نحوه ارسال',
        message: 'نحوه ارسال فاکتور را مشخص کنید؟',
        persistent: false,
        ok: {
          label: 'لینک فاکتور/پیش فاکتور'
        },
        cancel: {
          label: 'لینک پرداخت',
          color: 'green',
          flat: true
        },
      }).onOk(() => {
        this.SendSMS({
          phoneNo: phoneNo,
          Sale_Num: sale_num,
          Message: `${item.CompID === '2' ? 'صاف' : 'نوران'}، سلام \n مشتری عزیز ${`(${customerName})`} شما می توانید از طریق لینک زیر اطلاعات ${ty} خود را مشاهده نمایید. لازم به ذکر است مدت اعتبار دسترسی به  ${ty} 1 روز می باشد \nhttps://ecapp-report.norl.ir/CustomerViewer?requestid=${requestid}`
        }).then(() => {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            message: 'پیامک ارسال گردید',
            position: 'top'
          })
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            message: 'پیامک ارسال نگردید',
            position: 'top'
          })
        })
      }).onCancel(() => {
        this.sendPay([
          {
            Cs_Pay: item.Sale_Pay,
            Cs_ID: item.Cs_ID,
            Cs_PayType: 0,
            Cs_Lock: 0,
            CustomText: `بابت فاکتور شماره ${item.Sale_Num}`,
            Cs_Mobile: item.Cs_Mobile
          }]).then(() => {
        })
      }).onDismiss(() => {
      })
    },
    backOrderStage1(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سفارش برگشت داده شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.returnOrderStage1(row.Sale_Num).then(() => {
          this.$q.notify({
            message: `سفارش ${row.Sale_Num} برگشت داده شود`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          this.$emit('refresh-data');
        });
      })
    },
    backOrderStage2(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سفارش برگشت داده شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.returnOrderStage2(row.Sale_Num).then(() => {
          this.$q.notify({
            message: `سفارش ${row.Sale_Num} برگشت داده شد`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          this.$emit('refresh-data');
        });
      })
    },
    deleteHava(sale_num) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف حواله اطمینان ذارید',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.deleteHavaleh(sale_num).then((res) => {
          this.$emit('refresh-data')
          if (eval(res.data).msg === 'success') {
            this.$q.notify({
              type: 'positive',
              color: 'positive',
              position: 'top',
              message: 'حواله حذف گردید'
            });
          }
        })
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.showCustomerFullInfo = true;
      })
    },
    showOrderDetails(row) {
      if (this.detailsType === 'order') {
        this.selectedSaleNum = row.Sale_Num;
      } else {
        this.selectedSaleNum = row.Order_Num;
      }
      this.showOrderDetailsDialog = true;
    },
    showHavaDetails(row) {
      this.selectedSaleNum = row.Order_Num;
      this.selectedSaleKind = row.Sale_Kind
      if (this.detailsType === 'factor') {
        this.selectedHavaNum = row.Hava_Num
      } else {
        this.selectedHavaNum = row.Sale_Num
      }
      this.showHavaDetailsDialog = true;
    },
    showOrderTimeLine(row) {
      if (this.orderTrace) {
        this.selectedSaleNum = row.Sale_Num;
        this.selectedSaleDate = row.Sale_Date
      } else {
        this.selectedSaleNum = row.Order_Num;
        this.selectedSaleDate = row.Sale_Date
      }
      this.selectedItem = row;
      this.showTimeLineDialog = true;
    },
    refreshPrice(row) {
      this.refreshOrderPrice(row.Sale_Num).then((res) => {
        if (res.data.length > 0) {
          row.Sale_Pay = res.data[0].Sale_Pay;
        }
      })
    },
    setSaleStateFlag(row) {
      if (row.LastTraceinfo !== 'نحوه بازپرداخت فاکتور' && ![1139, 3218, 5183].includes(row.Cs_ID)) {
        this.$q.notify({
          message: `نحوه بازپرداخت سفارش مشخص نشده است`,
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.changeSaleState(row, row.Sale_PayDay === 0)
      }
    },
    changeSaleState(row, cash) {
      this.setSaleState({
        sale_num: row.Sale_Num,
        cash: cash
      }).then((res) => {
        if (res.data.msg === "success") {
          this.$q.notify({
            message: ` اینجانب متعهد می گردم کلیه اقدامات لازم جهت اخذ تاییدیه از مشتری بابت سفارش را گرفته و تضمین می نمایم که اقلام سفارش توسط مشتری مورد تایید و نیاز می باشد`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          this.$emit('change-order-state', {data: row, state: 1});
        } else {
          this.$q.notify({
            message: res.data.msg,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        }
      })
    },
    setFinalSaleState(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'آیا شما متعهد میگردید که کلیه بررسی های مالی لازم و مراحل اخذ مجوزهای مورد نیاز (در صورت لزوم) برای تایید نهایی سفارش را انجام داده اید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setFinalOrder(row.Sale_Num).then((res) => {
          if (res.data.msg === 'success') {
            this.$q.notify({
              message: `سفارش ${row.Sale_Num}تایید گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            row.Sale_StateModir = 1
            this.$emit('refresh-data', row);
          }
        })
      })
    },
    setFactorSaleState(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'فاکتور نهایی شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setFactorState({
          sale_num: row.Sale_Num,
          state: 1
        }).then((res) => {
          this.$emit('refresh-data');
          if (res.data.msg === 'success') {
            this.$q.notify({
              message: `سفارش ${row.Sale_Num}تایید گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        })
      })
    },
    setDriver(row) {
      this.selectedHavaNum = row.Sale_Num;
      this.driverDialog = true;
    },
    issueFinanceDocument(row) {
      const btn = document.getElementById(`factor${row.Sale_Num}`)
      btn.disabled = true
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند حسابداری فاکتور صادر شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.$emit('start-issue-finance', row);
        this.issueFactorDocument({
          Sale_Num: row.Sale_Num,
          Sale_Kind: row.Sale_Kind,
          Cs_Code: row.Cs_Code
        }).then((res) => {
          if (res.result === -1) {
            this.$q.notify({
              message: res.msg,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
            this.$emit('stop-issue-finance', row);
            btn.disabled = false
          } else {
            this.$q.notify({
              message: `فاکتور در سیستم محاسبان به شماره سند ${res.msg} به ثبت رسید`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            this.$emit('issue-finance-success', row);
            this.$emit('stop-issue-finance', row);
            btn.disabled = false
          }
        }).catch(() => {
          this.$emit('stop-issue-finance', row);
          btn.disabled = false
        })
      }).onCancel(() => {
        this.$emit('stop-issue-finance', row);
        btn.disabled = false
      })
    }
  },
  computed: {
    recordList: function () {
      if (this.expired) {
        return this.items.filter(item => item.DIFF > 365)
      } else {
        return this.items
      }
    },
    expiredList: function () {
      if (this.recordList !== undefined) {
        return this.recordList.filter(item => item.DIFF > 365)
      } else {
        return []
      }
    },
    companyListUniq: function () {
      return this.lodash.uniqBy(this.items, 'CompName')
    },
    stateListUniq: function () {
      return this.lodash.uniqBy(this.items, 'State_Name')
    },
    cityListUniq: function () {
      return this.lodash.uniqBy(this.items, 'City_Name')
    }
  },
  created() {
    this.$store.state.userId = window.localStorage.getItem("userID");
    this.groupData = this.lodash(this.items).groupBy('City_Name')
        .map(function (data, City_Name) {
          return {
            City_Name: City_Name,
            sum: data.map(item => item.Sale_Pay).reduce((accumulator, curr) => accumulator + curr),
            count: data.map(item => item.Sale_Pay).length,
            profit: data.map(item => (item.Sale_Pay - (item.BuyDay_Pay))).reduce((accumulator, curr) => accumulator + curr)
          };
        }).value();
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}

.fixed-header-position {
  position: sticky;
  top: 0;
  background: cadetblue;
  z-index: 1000
}
</style>